function hasClass(el, cls) {
  return (
    el.className && new RegExp('(^|\\s)' + cls + '(\\s|$)').test(el.className)
  )
}

function addClass(el, cls) {
  if (!hasClass(el, cls)) {
    let className = el.className
    el.className += className ? ' ' + cls : cls
  }
}

function removeClass(el, cls) {
  let reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
  el.className = el.className
    .replace(reg, ' ')
    .replace(/^\s\s*/, '')
    .replace(/\s\s*$/, '')
}

function toggleClass(el, cls) {
  if (hasClass(el, cls)) {
    removeClass(el, cls)
  } else {
    addClass(el, cls)
  }
}

// 获取el距离页面最顶部的距离
function getOffsetTop(el) {
  let actualTop = el.offsetTop
  let current = el.offsetParent

  while (current !== null) {
    actualTop += current.offsetTop
    current = current.offsetParent
  }

  return actualTop
}

// 展示弹窗时，阻止页面滚动
function stopScroll() {
  // 打开弹窗前，页面就已经是fixed定位，那就不要动它
  if (getComputedStyle(document.body).position === 'absolute') return
  let top = document.body.scrollTop || document.documentElement.scrollTop
  // 缓存老样式
  const historyStyle = document.body.style.cssText

  // 样式
  const styles = {
    position: 'absolute',
    // top: `${-1 * top}px`,
    width: '10rem',
    left: '50%',
    overflow: 'hidden',
    'margin-left': '-5rem',

    '-ms-transform': 'none', // 避免之前历史到处写的居中逻辑影响
    transform: 'none' // 避免之前历史到处写的居中逻辑影响
  }
  const styleText = Object.keys(styles).reduce(
    (all, key) => `${all}${key}:${styles[key]};`,
    ''
  )

  document.body.style.cssText = styleText

  // 加个标志位，代表body中的fixed是我加的
  document.body.setAttribute('data-stop-scroll', true)
  // 设置前的缓存老样式，在恢复时设置回去
  document.body.setAttribute('data-stop-scroll-his-style', historyStyle)
  // 当前滚动条距离记录在这里
  document.body.setAttribute('data-stop-scroll-top', top)
}

// 隐藏弹窗时，恢复页面的滚动
function recoverScroll() {
  // body是fixed定位，且这个fixed定位是我加的，满足这两个条件才恢复滚动（因为有可能弹窗打开前页面本身就是fixed的）
  if (
    getComputedStyle(document.body).position === 'absolute' &&
    document.body.hasAttribute('data-stop-scroll')
  ) {
    const historyStyle =
      document.body.getAttribute('data-stop-scroll-his-style') || ''

    // let top = -parseInt(document.body.style.top)
    let top = document.body.getAttribute('data-stop-scroll-top') || ''
    document.body.style.cssText = historyStyle
    if (top) {
      window.scrollTo(0, top)
    }
    // 移除标志位
    document.body.removeAttribute('data-stop-scroll')
  }
}

function dataURLtoBlob(dataurl) {
  let arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

// 展示弹窗时，阻止背景滚动【基础功能】
function baseStopScroll() {
  let top = document.body.scrollTop || document.documentElement.scrollTop
  document.body.style.width = '100%'
  document.body.style.position = 'fixed'
  document.body.style.top = `${-1 * top}px`
}
// 隐藏弹窗时，恢复背景的滚动【基础功能】
function baseRecoverScroll() {
  let top = -parseInt(document.body.style.top)
  document.body.style.position = 'static'
  document.body.style.top = 0
  window.scrollTo(0, top)
}

// pase dom
function parseDom(html) {
  let ele = document.createElement('div')
  ele.innerHTML = html
  return ele.childNodes[0]
}

export {
  parseDom,
  hasClass,
  addClass,
  removeClass,
  toggleClass,
  getOffsetTop,
  stopScroll,
  recoverScroll,
  dataURLtoBlob,
  baseStopScroll,
  baseRecoverScroll
}
